export default __webpack_public_path__ + "static/media/gaming.e9176102.svg";